export const oneTrustLocalStorageKeyName = 'oneTrustTcf_isImplicitConsent';
export const oneTrustLocalStorageValue = 'true';
